
/**
 * @class Intended to resolve settings fields that need to be computed following another logic.
 * Configuration is computed when creating an instance of this class, and can be retrieved with
 * getConfiguration getter.
 */
class ConfigurationAdapter {
    constructor(querySource = document) {
        const keysToAdapt = [ 'isMultiProperty', 'widgetType', 'isConnected', 'language' ];
        const strategiesToAdapt = {
            isMultiProperty : () => {
                const hasAttributeInConfig = typeof this.config.isMultiProperty === 'boolean';

                if (hasAttributeInConfig) {
                    return this.config.isMultiProperty;
                }

                return !!this.config.channelId && !this.config.propertyCode;
            },
            language        : () => this.config.language,
            isConnected     : (params) => {
                const hasAttributeInParams = typeof params?.isConnected === 'boolean';

                if (hasAttributeInParams) {
                    return params.isConnected;
                }

                if (!querySource) {
                    // you should NOT run this in the server environment
                    return false;
                }

                const someWidgetRendered =  !!querySource.querySelector('[data-kbe-rates]')
                    || !!querySource.querySelector('[data-kbe-offers]')
                    || !!querySource.querySelector('[data-kbe-hotelslist]');
                return someWidgetRendered;
            },
            widgetType: () => (!this.config.widgetType ? 'KUBE' : this.config.widgetType),
        };

        this.keysToAdapt = keysToAdapt;
        this.strategiesToAdapt = strategiesToAdapt;
    }

    setConfig(config) {
        this.config = config;
        this.keysToAdapt.forEach((key) => {
            this.config[key] = key in this.strategiesToAdapt ? this.strategiesToAdapt[key]() : this.config[key];
        });
    }

    setKey(key, config) {
        if (this.keysToAdapt.includes(key) && key in this.strategiesToAdapt) {
            // eslint-disable-next-line no-param-reassign
            config[key] = this.strategiesToAdapt[key](config);
        }
    }

    getConfiguration() {
        return this.config || {};
    }
}

export default ConfigurationAdapter;
